import { useSafeAppBridge } from "./useSafeAppBridge";

export function useCustomFetch() {
    const shopify = useSafeAppBridge();

    return async (url, model) => {
        const token = localStorage.getItem('token');
        const options = { headers: { 'Content-Type': 'application/json' } };

        if (model) {
            options.method = 'POST';
            options.body = JSON.stringify(model);
        } else {
            options.method = 'GET';
        }

        if (token) {
            options.headers.Authorization = `Bearer ${token}`;
        }

        const response = await fetch(url, options);

        let data = null;
        try {
            data = await response.json();
        } catch (err) {
            // Not JSON, or empty response
        }

        if (!response.ok) {
            if (response.status === 401) {
                localStorage.removeItem('token');
                localStorage.removeItem('user');

                // Check for reauthorizeUrl in error payload
                if (data && data.reauthorizeUrl) {
                    if (shopify) {
                        window.open(data.reauthorizeUrl, '_top');
                    }
                    else {
                        window.location.href = data.reauthorizeUrl;
                    }
                } else {
                    window.location.href = '/login';
                }
            } else {
                return { redirectUrl: '/error' };
            }
        }

        return data;
    };
}